import Link from 'components/ui/AppLink';
import { Box, Typography } from '@mui/material';
import React, { Fragment } from 'react';
import Contributor, { ContributorProps } from './Contributor';

import { Publisher } from '../../shared/types';
import { sortArray } from '../../utils/sorting.utils';
import { getPublisherUrl } from '../../utils/utils';

import { Grid } from '@mui/material';

interface ArticleContributorsProps {
    contributors: ContributorProps[];
    publishedBy: Publisher;
    narrow?: boolean;
}

const ArticleContributorList = (props: ArticleContributorsProps) => {
    const { contributors, publishedBy, narrow = false } = props;

    if (!contributors.length) {
        return null;
    }

    return (
        <Box
            sx={(theme) => ({
                mb: 6,
                '& > p > a': {
                    fontSize: theme.typography.caption.fontSize,
                    [theme.breakpoints.up('xl')]: { fontSize: 12 },
                },
            })}
        >
            <Typography sx={{ mt: 0, mb: 1 }} variant="h5">
                Contributors
            </Typography>
            <Typography
                id="article-page-contributors-published-by"
                component="p"
                variant="caption"
                sx={{
                    color: 'text.secondary',
                    mt: 0,
                    mb: 2,
                }}
            >
                This article is published by{' '}
                <Link
                    sx={{ fontWeight: 'fontWeightBold' }}
                    to={getPublisherUrl(publishedBy)}
                >
                    {publishedBy?.name}
                </Link>
            </Typography>
            <Grid container spacing={2}>
                {sortArray(contributors, 'name').map((c: ContributorProps) => (
                    <Fragment key={c._id}>
                        <Grid
                            size={{
                                xs: 12,
                                sm: 6,
                                md: narrow ? 4 : 12,
                            }}
                        >
                            <Contributor {...c} />
                        </Grid>
                    </Fragment>
                ))}
            </Grid>
        </Box>
    );
};

export default ArticleContributorList;
